import { PageHeader } from '@celltrak/ui-components';

const PayersHeader = () => (
  <header>
    <PageHeader title="Payers" />
  </header>
);

export default PayersHeader;
